/* tslint:disable */
/* eslint-disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { PaginatedList } from '../../models/paginator/paginated-list';
import { SurveyRespondentQuestionnaireModel } from '../../models/survey-respondent-questionnaire-model';

export interface UserAssociatedQuestionnairesGetParams {
  accountGuid?: string;
  pageNumber?: number;
  pageSize?: number;
  scope?: 'active-account' | 'all-accounts';
  sortKey?:
    | 'questionnaireName'
    | 'surveyRespondentName'
    | 'startedAt'
    | 'status'
    | 'accountName';
  sortDirection?: 'asc' | 'desc';
  userGuid: string;
}

export function userAssociatedQuestionnairesGet(
  http: HttpClient,
  rootUrl: string,
  params: UserAssociatedQuestionnairesGetParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>> {
  const rb = new RequestBuilder(
    rootUrl,
    userAssociatedQuestionnairesGet.PATH,
    'get',
  );
  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  if (params.accountGuid) {
    rb.query('accountGuid', params.accountGuid);
  }
  if (params.scope) {
    rb.query('scope', params.scope);
  }
  if (params.pageNumber) {
    rb.query('pageNumber', params.pageNumber);
  }
  if (params.pageSize) {
    rb.query('pageSize', params.pageSize);
  }
  if (params.sortKey) {
    rb.query('sortKey', params.sortKey);
  }
  if (params.sortDirection) {
    rb.query('sortDirection', params.sortDirection);
  }

  rb.path('userGuid', params.userGuid, { style: 'simple' });

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter((r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>;
      }),
    );
}

userAssociatedQuestionnairesGet.PATH =
  '/api/v1/users/{userGuid}/associated-questionnaires';
